// extracted by mini-css-extract-plugin
module.exports = {"container":"filter-view_container__1FlZ5"};